/**
 * Support Handlers — SUPPORT_MESSAGE_RECEIVED, SUPPORT_CONVERSATION_UPDATE, SUPPORT_MESSAGES_READ
 *
 * Listens for support chat socket events and updates the support store.
 */

import type { Socket } from "socket.io-client";
import { EVENTS } from "@/constants/events";
import { useSupportStore } from "../supportStore";
import type {
  SupportMessageReceivedPayload,
  SupportConversationUpdatePayload,
  SupportMessagesReadPayload,
} from "@bash/shared";

export function registerSupportHandlers(socket: Socket): () => void {
  const supportStore = useSupportStore;

  const handleMessageReceived = (data: SupportMessageReceivedPayload) => {
    supportStore.getState().handleMessageReceived(data);
  };

  const handleConversationUpdate = (data: SupportConversationUpdatePayload) => {
    supportStore.getState().handleConversationUpdate(data);
  };

  const handleMessagesRead = (data: SupportMessagesReadPayload) => {
    supportStore.getState().handleMessagesRead(data);
  };

  socket.on(EVENTS.SUPPORT_MESSAGE_RECEIVED, handleMessageReceived);
  socket.on(EVENTS.SUPPORT_CONVERSATION_UPDATE, handleConversationUpdate);
  socket.on(EVENTS.SUPPORT_MESSAGES_READ, handleMessagesRead);

  return () => {
    socket.off(EVENTS.SUPPORT_MESSAGE_RECEIVED, handleMessageReceived);
    socket.off(EVENTS.SUPPORT_CONVERSATION_UPDATE, handleConversationUpdate);
    socket.off(EVENTS.SUPPORT_MESSAGES_READ, handleMessagesRead);
  };
}
